import callAxios from "../../plugins/axios/call";

export default remote => ({
    create: (search_code, id_solution, data) => callAxios(remote, 'post', `booking/flight/${search_code}/${encodeURIComponent(id_solution)}`, data, 10)
});
